import { stripPhone } from './format';

export const required = (v, label = 'This field') =>
  (v === undefined || v === null || String(v).trim() === '' ? `${label} is required` : '');

export const phone = (v) => {
  const d = stripPhone(v);
  if (!d) return 'Mobile number is required';
  if (d.length < 7 || d.length > 12) return 'Enter a valid mobile number';
  return '';
};

export const password = (v) => {
  if (!v) return 'Password is required';
  if (v.length < 8) return 'Use at least 8 characters';
  return '';
};

export const email = (v) => {
  if (!v) return '';
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Enter a valid email address';
};

export const ic = (v) => {
  const d = String(v || '').replace(/\D/g, '');
  if (!d) return 'IC number is required';
  return d.length === 12 ? '' : 'IC number must be 12 digits';
};

/** Runs a map of { field: validatorFn } against values; returns { field: message } for failures. */
export const validate = (values, rules) =>
  Object.entries(rules).reduce((errors, [field, fn]) => {
    const msg = fn(values[field], values);
    if (msg) errors[field] = msg;
    return errors;
  }, {});
